import React from 'react';
import { Box } from '@material-ui/core';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';
import { TransactionType } from 'globals/types';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import reportLocales from 'globals/locales/report';
import FsBodyExtraSmall from 'ui-elements/typography/FsBodyExtraSmall';
import FsCategoryIconLoader from 'ui-elements/image-loaders/FsCategoryIconLoader';
import {
  Category,
  CategoryLabel,
  HeaderBox,
  NameContainerBox,
  RowBox,
  ValueBox,
} from './TransactionDetails.style-elements';

const { categoryLabel } = reportLocales.changeCategoryModal;

interface TransactionDetailsProps {
  type?: TransactionType;
  id: string;
  name: string;
  date: string;
  displayValue: string;
  category: string;
}

const TransactionDetails: React.FC<TransactionDetailsProps> = ({
  date,
  name,
  displayValue,
  category,
}) => {
  return (
    <RowBox marginBottom={4}>
      <HeaderBox>
        <Box>
          <FsBodyExtraSmall>{date}</FsBodyExtraSmall>
        </Box>
        <NameContainerBox>
          <FsBodySmallBold>{name}</FsBodySmallBold>
          <Box display="flex" alignItems="center">
            <CategoryLabel>{categoryLabel}:</CategoryLabel>
            <FsCategoryIconLoader categoryName={category} size={14} />
            <Category component="span">{category}</Category>
            <CategoryLabel>{category}</CategoryLabel>
          </Box>
        </NameContainerBox>
      </HeaderBox>
      <ValueBox>
        <FsBodySmall component="span">{displayValue}</FsBodySmall>
      </ValueBox>
    </RowBox>
  );
};

export default TransactionDetails;
